import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import journalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import journalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import OxygeneSaturationDeclaredJournalEvent from 'parog-web/models/oxygene-saturation-declared-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';

export default class OxygeneSaturationEditionFormComponent extends journalEventBasedComponent {
  static override forcDisplayName = 'Saturation en oxygène (SpO2)';
  static override fullComponentId = 'oxygene-saturation/edition-form';
  static override journalEventClass = OxygeneSaturationDeclaredJournalEvent;

  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override journalEventProperties = ['occurredAt', 'comments', 'spo2'];
  override retrieveJournalEvent =
    journalEventRetrievalStrategies.sourceJournalEvent;

  override get toastMessage() {
    return this.session.patient
      ? {
          message: 'Votre mesure a bien été prise en compte',
          title: 'Saturation en oxygène'
        }
      : super.toastMessage;
  }

  override get validations() {
    return this.journalEventClass.validations(this.intl);
  }

  override retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) model.occurredAt = new Date();
    return model;
  }

  override save = async () => {
    await super.save();
    this.analytics.trackPatientMeasurement('oxygene-saturation');
  };

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='two fields'>
          <div class='field'>
            <Form.Date
              @labelName='Date de la mesure'
              @propertyName='occurredAt'
            />
          </div>
          <div class='field'>
            <Form.NumberInput
              @labelName='Saturation en oxygène (%)'
              @propertyName='spo2'
              @min='50'
              @max='100'
            />
          </div>
        </div>
        <div class='field'>
          <Form.TextArea @labelName='Commentaires' @propertyName='comments' />
        </div>
      </:content>
    </Provider>
  </template>
}
